import { createApiSaga } from "redux-store/api-sagas";
import { fullDeviceService } from "service/full-device";

import {
  FULL_DEVICES_LOAD,
  FULL_DEVICES_LOAD_FAILURE,
  FULL_DEVICES_LOAD_SUCCESS,
} from "./actions";

const fullDevicesLoadSaga = createApiSaga({
  service: fullDeviceService.load,
  serviceName: "fullDeviceService.load",
  fetchAction: FULL_DEVICES_LOAD,
  successAction: FULL_DEVICES_LOAD_SUCCESS,
  failureAction: FULL_DEVICES_LOAD_FAILURE,
});

export { fullDevicesLoadSaga };
